import React from 'react';
import styled from '@mui/system/styled';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import CircularProgress from '@mui/material/CircularProgress';

const Loader = ({ t }) => {
	const StyledContainer = styled('div')(({ theme }) => ({
		display: 'flex',
		flex: 1,
		height: theme.spacing(9),
		justifyContent: 'center',
		alignItems: 'center'
	}));

	return (
		<StyledContainer>
			<CircularProgress />
		</StyledContainer>
	);
};

Loader.propTypes = {
	t: PropTypes.func,
	tracking: PropTypes.object
};

export default withTranslation(null, { keyPrefix: '' })(Loader);
